import Immutable from 'seamless-immutable'
import {FEE} from 'actions'

const reducer = (state = Immutable({}), {type, response}) => {
  if (type === FEE) {
    return response ? Immutable.merge(state, response) : state
  }
  return state
}

export default reducer
